import React from "react";
import {
	changeActionLabel,
	changeEntryPath,
	lineRangeLabel,
} from "./schemaOptimizerChangeLog";

export default function SchemaOptimizerChangeTooltip({
	entry,
	schemaSnippet,
	lineStart,
	lineEnd,
	docked = false,
}) {
	if (!entry) return null;

	const action = String(entry.action || "").toLowerCase();
	const isManual = action === "manual";
	const range = lineRangeLabel(lineStart, lineEnd);
	const path = isManual
		? entry.property || changeEntryPath(entry)
		: changeEntryPath(entry);
	const snippet =
		schemaSnippet && schemaSnippet.length > 480
			? `${schemaSnippet.slice(0, 480)}…`
			: schemaSnippet;

	return (
		<div
			className={`schema-optimizer__change-tooltip${
				docked ? " schema-optimizer__change-tooltip--docked" : ""
			}`}
			role="tooltip"
		>
			<div className="schema-optimizer__change-tooltip-title-row">
				<span
					className={`schema-optimizer__change-tooltip-icon${
						isManual ? " schema-optimizer__change-tooltip-icon--manual" : ""
					}`}
					aria-hidden
				>
					<i className={isManual ? "fas fa-hand-paper" : "fas fa-lightbulb"} />
				</span>
				<span className="schema-optimizer__change-tooltip-title">
					{isManual ? "Manual add required" : "Reason"}
				</span>
			</div>

			<div className="schema-optimizer__change-tooltip-meta">
				<span
					className={`schema-optimizer__change-tooltip-action schema-optimizer__change-tooltip-action--${action}`}
				>
					{changeActionLabel(entry.action).toUpperCase()}
					{range ? ` · ${range.toUpperCase()}` : ""}
				</span>
				{path && (
					<span className="schema-optimizer__change-tooltip-path">{path}</span>
				)}
			</div>

			{snippet && (
				<div className="schema-optimizer__change-tooltip-section">
					<div className="schema-optimizer__change-tooltip-label">Schema block</div>
					<pre className="schema-optimizer__change-tooltip-code mb-0">{snippet}</pre>
				</div>
			)}

			{entry.reason && (
				<div className="schema-optimizer__change-tooltip-section schema-optimizer__change-tooltip-section--reason">
					<div className="schema-optimizer__change-tooltip-label">Reason</div>
					<p className="schema-optimizer__change-tooltip-reason mb-0">{entry.reason}</p>
				</div>
			)}
		</div>
	);
}
